import { useState, useEffect } from "react";
import { Button, Stack, Chip, IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate } from "react-router-dom";
import { fetchAllGoodsReturnInfo, fetchGoodsReturnMaterialList, fetchGoodsReturnStatusHistory } from "Service/ApiService";

const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

const GoodAndRetunsListController = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [goodsReturnsListData, setGoodsReturnsListData] = useState([]);

  // 🔥 NEW STATE FOR DIALOG
  const [openViewDialog, setOpenViewDialog] = useState(false);
  // const [selectedGroupItems, setSelectedGroupItems] = useState([]);

  // 🔥 STATUS HISTORY DIALOG STATE
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusHistory, setStatusHistory] = useState([]);
  const [statusHistoryLoading, setStatusHistoryLoading] = useState(false);

  const [materialList, setMaterialList] = useState([]);
  const [materialLoading, setMaterialLoading] = useState(false);
  const [cloading, setCloading] = useState(false);

  const [deliveryNumber, setDeliveryNumber] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");

  const debouncedDeliveryNumber = useDebounce(deliveryNumber, 500);
  const debouncedInvoiceNumber = useDebounce(invoiceNumber, 500);


  const handleOpenView = async (goodsReturnInvoiceDtlsId) => {
    try {
      setOpenViewDialog(true);
      setMaterialLoading(true);
      setMaterialList([]);

      const res = await fetchGoodsReturnMaterialList(goodsReturnInvoiceDtlsId);

      if (res?.success === "true" && Array.isArray(res.goodsReturnList)) {
        setMaterialList(res.goodsReturnList);
      } else {
        setMaterialList([]);
      }
    } catch (err) {
      console.error("Failed to fetch material list:", err);
      setMaterialList([]);
    } finally {
      setMaterialLoading(false);
    }
  };


  const handleCloseView = () => {
    setOpenViewDialog(false);
  };

  const handleOpenStatus = async (grInvoiceDtlsId) => {
    try {
      setOpenStatusDialog(true);
      setStatusHistoryLoading(true);
      setStatusHistory([]);

      const res = await fetchGoodsReturnStatusHistory(grInvoiceDtlsId);

      // API returns `statusHistory` array — keep a fallback for `statusHistoryList` for compatibility
      if (res?.success === "true" && Array.isArray(res.statusHistory)) {
        setStatusHistory(res.statusHistory);
      } else if (res?.success === "true" && Array.isArray(res.statusHistoryList)) {
        setStatusHistory(res.statusHistoryList);
      } else {
        setStatusHistory([]);
      }
    } catch (err) {
      console.error("Failed to fetch status history:", err);
      setStatusHistory([]);
    } finally {
      setStatusHistoryLoading(false);
    }
  };

  const handleCloseStatus = () => {
    setOpenStatusDialog(false);
  };

  const columns = [
    { field: "delivery_number", headerName: "Delivery Number", flex: 1 },
    { field: "invoice_number", headerName: "Invoice Number", flex: 1 },
    { field: "invoice_date", headerName: "Invoice Date", flex: 1 },
    { field: "partyDisplay", headerName: "Customer", flex: 1 },
    { field: "fromPartyDisplay", headerName: "From Customer", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const { hodStatus, allDivisionHodStatus, asnStatus, salesAccStatus } = params.row || {};

        const isApproved = (v) => v?.toLowerCase() === "approved";
        const isRejected = (v) => v?.toLowerCase() === "rejected";

        const approved =
          (isApproved(hodStatus) && isApproved(allDivisionHodStatus)) || isApproved(asnStatus) || isApproved(salesAccStatus);

        const rejected =
          isRejected(hodStatus) ||
          isRejected(allDivisionHodStatus) || isRejected(asnStatus) || isRejected(salesAccStatus);

        let status = "Pending";
        let chipColor = "warning"; // ✅ SAFE DEFAULT

        if (approved) {
          status = "Approved";
          chipColor = "success";
        } else if (rejected) {
          status = "Rejected";
          chipColor = "error";
        }

        return (
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Chip
              label={status}
              color={chipColor}
              size="small"
              sx={{ fontWeight: 600 }}
            />

            {/* <Tooltip title="Status History">
              <IconButton size="small" onClick={() => handleOpenStatus(params.row.grInvoiceDtlsId)} color="primary">
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip> */}
          </Stack>
        );
      },
    },
    {
      field: "transferStatus",
      headerName: "Transfer Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => (params.value ? params.value : "-")
    },

    // {
    //   field: "transferStatus",
    //   headerName: "Transfer Status",
    //   flex: 1,
    //   renderCell: (params) => {
    //     const raw = params.row?.transferStatus ?? 'Pending';
    //     const val = String(raw).trim();
    //     const lower = val.toLowerCase();

    //     let chipColor = 'warning';
    //     let label = val || 'Pending';

    //     if (lower === 'pending' || label === '') {
    //       chipColor = 'warning';
    //       label = 'Pending';
    //     } else if (lower === 'transferred' || lower === 'completed' || lower === 'success') {
    //       chipColor = 'success';
    //       label = 'Transferred';
    //     } else if (lower === 'failed' || lower === 'rejected' || lower === 'error') {
    //       chipColor = 'error';
    //       label = 'Failed';
    //     } else if (lower === 'inprogress' || lower === 'in progress' || lower === 'processing') {
    //       chipColor = 'info';
    //       label = 'In Progress';
    //     } else {
    //       chipColor = 'default';
    //     }

    //     return (
    //       <Chip label={label} color={chipColor} size="small" sx={{ fontWeight: 600 }} />
    //     );
    //   },
    // },
    // {
    //   field: "remark",
    //   headerName: "Remark",
    //   flex: 1.5,
    //   renderCell: (params) => {
    //     return params.row.hodComment || params.row.allDivisionHodComment || params.row.salesAccComment || "-";
    //   }
    // },
    {
      field: "transfer",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      flex: 1.5,
      renderCell: (params) => {
        const { hodStatus, allDivisionHodStatus, asnStatus, salesAccStatus } = params.row || {};

        const isApproved = (v) => v?.toLowerCase() === "approved";

        const approved =
          (isApproved(hodStatus) && isApproved(allDivisionHodStatus)) || isApproved(asnStatus);

        console.log(params.row.isTransferred);

        return (
          <Stack direction="row" spacing={1}>
            {/* VIEW BUTTON */}
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleOpenView(params.row.grInvoiceDtlsId)}
            >
              View
            </Button>

            <Button
              variant="contained"
              size="small"
              color="info"
              disabled={!approved || params.row.isTransferred}
              sx={{
                "&.Mui-disabled": {
                  backgroundColor: "#e0e0e0 !important",
                  color: "#9e9e9e",
                },
              }}
              onClick={() =>
                navigate("/good-returns-transfer", {
                  state: { partyCode: params.row.partyCode, fromPartyCode: params.row.fromPartyCode, goodsReturnInvoiceDtlsId: params.row.grInvoiceDtlsId, deliveryNumber: params.row.delivery_number, invoiceNumber: params.row.invoice_number },
                })
              }
            >
              Transfer
            </Button>
          </Stack>
        );
      },
    },
  ];

  useEffect(() => {
    setCloading(true);
    if (!user?.userCode) return;

    fetchGoodsReturnsList({
      userCode: user.userCode,
      deliveryNumber: debouncedDeliveryNumber,
      invoiceNumber: debouncedInvoiceNumber,
      setGoodsReturnsListData,
      setCloading,
    });
  }, [user?.userCode]);

  useEffect(() => {
    //  setCloading(true);
    if (!user?.userCode) return;

    fetchGoodsReturnsList({
      userCode: user.userCode,
      deliveryNumber: debouncedDeliveryNumber,
      invoiceNumber: debouncedInvoiceNumber,
      setGoodsReturnsListData,
      setCloading,
    });
  }, [debouncedDeliveryNumber, debouncedInvoiceNumber]);


  const fetchGoodsReturnsList = async ({
    userCode,
    deliveryNumber,
    invoiceNumber,
    setGoodsReturnsListData,
    setCloading,
  }) => {
    try {

      const res = await fetchAllGoodsReturnInfo(
        userCode,
        deliveryNumber,
        invoiceNumber
      );

      if (res?.success === "true" && Array.isArray(res.goodsReturnList)) {
        setGoodsReturnsListData(res.goodsReturnList);
      } else {
        setGoodsReturnsListData([]);
      }
    } catch (error) {
      console.error("Failed to fetch goods return list:", error);
      setGoodsReturnsListData([]);
    } finally {
      setCloading(false);
    }
  };


  return {
    deliveryNumber,
    invoiceNumber,
    setDeliveryNumber,
    setInvoiceNumber,
    cloading,
    columns,
    goodsReturnsListData,
    openViewDialog,
    materialList,
    materialLoading,
    handleCloseView,

    // Status history dialog props
    openStatusDialog,
    statusHistory,
    statusHistoryLoading,
    handleCloseStatus,
  };
};

export default GoodAndRetunsListController;
